export enum LearningTimeLimit {
  none,
  slower,
  slow,
  normal,
  fast,
}
